var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdytuj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2439 0.433776L15.2246 0.416211C14.8547 0.0798136 14.3753 -0.105469 13.8746 -0.105469C13.3133 -0.105469 12.7744 0.131133 12.396 0.543616L5.24086 8.34373C5.17564 8.41481 5.12618 8.49869 5.0956 8.59001L4.25426 11.1015C4.15698 11.3919 4.2058 11.713 4.38483 11.9604C4.56529 12.2098 4.856 12.3588 5.16256 12.3588C5.29516 12.3588 5.42482 12.3316 5.54775 12.278L7.98374 11.2169C8.07231 11.1783 8.15176 11.1217 8.21694 11.0506L15.3721 3.25053C16.1167 2.43891 16.0593 1.17541 15.2439 0.433776ZM5.86623 10.6376L6.35993 9.16383L6.40157 9.11843L7.33728 9.96944L7.29564 10.0148L5.86623 10.6376ZM14.3519 2.3226L8.26916 8.95365L7.33345 8.10263L13.4162 1.47154C13.5352 1.34184 13.698 1.27039 13.8747 1.27039C14.0297 1.27039 14.1781 1.32781 14.293 1.43228L14.3123 1.44985C14.5649 1.67957 14.5826 2.07109 14.3519 2.3226Z",
    fill: "#4322C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8543 6.24196C13.4728 6.24196 13.1635 6.54997 13.1635 6.92989V12.7703C13.1635 13.7349 12.3753 14.5198 11.4065 14.5198H3.03324C2.06441 14.5198 1.27627 13.7349 1.27627 12.7703V4.50036C1.27627 3.5357 2.06445 2.75086 3.03324 2.75086H9.09385C9.47539 2.75086 9.78472 2.44285 9.78472 2.06293C9.78472 1.68301 9.47539 1.375 9.09385 1.375H3.03324C1.30252 1.375 -0.105469 2.77705 -0.105469 4.50036V12.7702C-0.105469 14.4935 1.30257 15.8956 3.03324 15.8956H11.4065C13.1371 15.8956 14.5452 14.4935 14.5452 12.7702V6.92989C14.5452 6.54997 14.2359 6.24196 13.8543 6.24196Z",
    fill: "#4322C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdytuj);
export default __webpack_public_path__ + "static/media/edytuj.9759af80ba820bccb9a138af52f4051d.svg";
export { ForwardRef as ReactComponent };